<template>
	<div class="ToAudit">
		<meta name="description" content="以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"/>
		<title>支付成功-以诺教育</title>
		<headTop></headTop>
	   <div class="audit">
	   		<div class="handle">
	   			<div class="handleL"></div>
	   			<div class="handleR">
	   				<p class="we">支付成功！</p>
	   				<p class="titlePay">您已成功支付“{{name}}”报名款</p>
	   				<span><router-link to="/orderList">查看订单>></router-link></span>
	   			</div>
	   		</div>
	   </div>
	   <Bottom></Bottom>
	</div>
</template>

<script>
	import headTop from "../headTop/headTop"
    import Bottom from "../Bottom/Bottom"
	export default{
		name:"PaySuccess",
		data(){
			return{
				id:this.$route.params.id,
				name:''
			}
		},
		mounted(){
			var that=this
			that.$ajax({
				method:"post",
				url:"/api/MyOrderDetail",
				params:{id:that.id}
			}).then(function(data){
				that.name=data.data.result[0].name
			}).catch(function(err){
				console.log(err)
			})
    var minHeight = $(window).height() + 'px';
    $('body').css({"min-height":minHeight});
		},
		components:{headTop,Bottom}
	}
  var minHeight = $(window).height() + 'px';
  $('body').css({"min-height":minHeight});
</script>

<style scoped="scoped">
	.ToAudit{width:100%;background:#f4f5f9;overflow: hidden;height:100%;}
	.audit{width:960px;height:450px;margin:30px auto 185px;background:#fff;overflow: hidden;}
	.handle{width:550px;height:95px;margin:120px auto 95px;}
	.handleL{width:95px;height:95px;background:url(../../assets/check1.png)no-repeat;float:left;}
	.handleR{width:425px;float:right;}
	.handleR span a:visited{color:#01b784;}
	.we{font-size: 24px;margin:5px 0 10px 0;}
	.titlePay{line-height:26px;}
	a:visited{color:#01b784;}
</style>



// WEBPACK FOOTER //
// PaySuccess.vue?6ba283b4